import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import {
    ArrowRight,
    Check,
    Download,
    Mail,
    MapPin,
    Phone,
    UserRound,
  } from "lucide-vue-next";
  import { getEstateMapPath } from "@/helpers/estateMapRoute";
  import { ProjectPageData } from "@/services/api/projectPageApi";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandSubdivisionPublicProjectPage',
  props: {
    pageData: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const content = computed(() => props.pageData.landSubContent ?? {});
  const aboutParagraphs = computed(() =>
    (content.value.aboutDescription || "")
      .split(/\n\s*\n/)
      .map((paragraph) => paragraph.trim())
      .filter(Boolean)
  );
  const heroStyle = computed(() =>
    props.pageData.backgroundImageUrl
      ? {
          backgroundImage: `linear-gradient(rgba(15, 23, 42, .35), rgba(15, 23, 42, .55)), url(${props.pageData.backgroundImageUrl})`,
        }
      : { background: "linear-gradient(135deg, #2f4058, #111a2d)" }
  );
  const heroButtonStyle = computed(() => ({
    backgroundColor: content.value.heroButtonColor || "#334e68",
  }));
  const agencyBarStyle = computed(() => ({
    backgroundColor: content.value.agency?.brandColor || "#1e3a5f",
  }));
  const contactCardStyle = computed(() => ({
    borderTopColor: content.value.agency?.brandColor || "#1e3a5f",
  }));
  const ctaStyle = computed(() => ({
    backgroundColor: content.value.callToAction?.footerColor || "#1e293b",
  }));
  const googleMapsUrl = computed(
    () =>
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        content.value.locationAddress || ""
      )}`
  );
  const masterplanUrl = computed(() =>
    getEstateMapPath(props.pageData.estateId || "", props.pageData.estateType)
  );
  const hasContactPerson = computed(
    () =>
      content.value.contact?.name ||
      content.value.contact?.phone ||
      content.value.contact?.email
  );
  const hasContact = computed(
    () => hasContactPerson.value || content.value.locationAddress
  );

const __returned__ = { props, content, aboutParagraphs, heroStyle, heroButtonStyle, agencyBarStyle, contactCardStyle, ctaStyle, googleMapsUrl, masterplanUrl, hasContactPerson, hasContact, computed, get ArrowRight() { return ArrowRight }, get Check() { return Check }, get Download() { return Download }, get Mail() { return Mail }, get MapPin() { return MapPin }, get Phone() { return Phone }, get UserRound() { return UserRound }, get getEstateMapPath() { return getEstateMapPath }, get ProjectPageData() { return ProjectPageData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})